import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import { XMarkIcon, CloudArrowUpIcon, CheckCircleIcon, ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { Button } from '../../components/ui/Button';
const SalesCallImportModal = ({ isOpen, onClose, onImport, importing, importResult, onDownloadTemplate, onDownloadSablon2 }) => {
    const fileInputRef = useRef(null);

    if (!isOpen) return null;

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            onImport(file);
        }
    };

    return createPortal(
        <div className="fixed inset-0 z-[9999] overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen p-4">
                <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
                <div className="relative bg-white dark:bg-slate-900 rounded-2xl shadow-2xl w-full max-w-3xl transform transition-all border border-slate-200 dark:border-slate-800">
                    <div className="flex items-center justify-between p-6 border-b border-slate-100 dark:border-slate-800">
                        <h3 className="text-xl font-bold text-slate-900 dark:text-white">Excel'den Ziyaret Aktar</h3>
                        <button onClick={onClose} className="p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-full text-slate-400 transition-colors">
                            <XMarkIcon className="w-6 h-6" />
                        </button>
                    </div>

                    <div className="p-6">
                        <div className="space-y-6">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 p-4 rounded-xl flex items-start gap-3">
                                    <div className="p-2 bg-blue-100 dark:bg-blue-800 rounded-lg text-blue-600 dark:text-blue-300 shrink-0">
                                        <ArrowDownTrayIcon className="w-5 h-5" />
                                    </div>
                                    <div className="min-w-0">
                                        <h4 className="text-sm font-bold text-blue-900 dark:text-blue-200">Şablonu Kullanın</h4>
                                        <p className="text-xs text-blue-700 dark:text-blue-400 mt-1">Lütfen formatın doğru olduğundan emin olmak için örnek Excel şablonunu kullanın.</p>
                                        <button onClick={onDownloadTemplate} className="text-xs font-bold text-blue-600 dark:text-blue-400 hover:underline mt-2">
                                            Şablonu İndir (.xlsx)
                                        </button>
                                    </div>
                                </div>

                                {onDownloadSablon2 && (
                                    <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 p-4 rounded-xl flex items-start gap-3">
                                        <div className="p-2 bg-blue-100 dark:bg-blue-800 rounded-lg text-blue-600 dark:text-blue-300 shrink-0">
                                            <ArrowDownTrayIcon className="w-5 h-5" />
                                        </div>
                                        <div className="min-w-0">
                                            <h4 className="text-sm font-bold text-blue-900 dark:text-blue-200">Şablon 2 Kullanın</h4>
                                            <p className="text-xs text-blue-700 dark:text-blue-400 mt-1">Lütfen formatın doğru olduğundan emin olmak için örnek Excel şablonunu kullanın.</p>
                                            <button
                                                type="button"
                                                onClick={onDownloadSablon2}
                                                className="text-xs font-bold text-blue-600 dark:text-blue-400 hover:underline mt-2"
                                            >
                                                Şablon 2 İndir
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div
                                className={`relative border-2 border-dashed rounded-2xl p-10 flex flex-col items-center justify-center transition-all ${importing ? 'border-blue-300 bg-blue-50/30' : 'border-slate-200 dark:border-slate-700 hover:border-blue-400 cursor-pointer'}`}
                                onClick={() => !importing && fileInputRef.current?.click()}
                            >
                                <input type="file" ref={fileInputRef} className="hidden" accept=".xlsx, .xls" onChange={handleFileChange} disabled={importing} />
                                <CloudArrowUpIcon className={`w-12 h-12 mb-4 ${importing ? 'text-blue-400 animate-bounce' : 'text-slate-400'}`} />
                                <p className="text-sm font-medium text-slate-700 dark:text-slate-200">Dosya seçin veya sürükleyin</p>
                                <p className="text-xs text-slate-400 mt-1">.xlsx veya .xls</p>
                            </div>

                            {importing && (
                                <div className="flex items-center justify-center gap-3 py-3 text-blue-600">
                                    <div className="animate-spin w-5 h-5 border-2 border-current border-t-transparent rounded-full"></div>
                                    <span className="font-medium">Yükleniyor...</span>
                                </div>
                            )}

                            {importResult && (
                                <div className={`${importResult.errors?.length > 0 && importResult.created === 0 && importResult.updated === 0 ? 'bg-red-50 dark:bg-red-900/30 border-red-200' : 'bg-green-50 dark:bg-green-900/30 border-green-200'} border p-4 rounded-xl`}>
                                    <div className={`flex items-center gap-2 mb-2 font-bold ${importResult.errors?.length > 0 && importResult.created === 0 && importResult.updated === 0 ? 'text-red-800 dark:text-red-200' : 'text-green-800 dark:text-green-200'}`}>
                                        <CheckCircleIcon className="w-5 h-5" />
                                        <span>{importResult.errors?.length > 0 && importResult.created === 0 && importResult.updated === 0 ? 'Aktarım Başarısız' : 'Aktarım Tamamlandı'}</span>
                                    </div>
                                    <ul className={`text-xs space-y-1 ${importResult.errors?.length > 0 && importResult.created === 0 && importResult.updated === 0 ? 'text-red-700 dark:text-red-300' : 'text-green-700 dark:text-green-300'}`}>
                                        <li>• {importResult.created} yeni kayıt</li>
                                        <li>• {importResult.updated} kayıt güncellendi</li>
                                        {importResult.errors?.length > 0 && (
                                            <>
                                                <li className="text-red-500 font-bold mt-2">• {importResult.errors.length} hata oluştu:</li>
                                                {importResult.errors.slice(0, 5).map((err, idx) => (
                                                    <li key={idx} className="text-red-400 ml-4 font-mono">
                                                        Satır {err.row}: {err.error}
                                                    </li>
                                                ))}
                                                {importResult.errors.length > 5 && <li className="text-red-400 ml-4">...ve {importResult.errors.length - 5} daha fazla hata.</li>}
                                            </>
                                        )}
                                    </ul>
                                </div>
                            )}
                        </div>

                        <div className="mt-8 flex justify-end">
                            <Button onClick={onClose} variant="outline" disabled={importing}>Kapat</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default SalesCallImportModal;
